export const formatDateTime = (date?: string | number | Date): string => {
  if (!date) return '—';

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) return '—';

  return parsedDate.toLocaleString(navigator.language, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const getBrowserTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Format an ISO timestamp for display in message lists (e.g. "Feb 5, 3:43 PM").
 */
export function formatMessageTimestamp(isoString: string): string {
  if (!isoString) return '—';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);
}
